import { render, staticRenderFns } from "./Tweet.vue?vue&type=template&id=63616e0f&scoped=true&"
import script from "./Tweet.vue?vue&type=script&lang=js&"
export * from "./Tweet.vue?vue&type=script&lang=js&"
import style0 from "./Tweet.vue?vue&type=style&index=0&id=63616e0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63616e0f",
  null
  
)

export default component.exports